import instance from "./service"

export const ContactListingsService = instance


// WEBPACK FOOTER //
// ./src/state/listing/contact/services/index.ts